import { Component, Input, OnInit } from '@angular/core';
import { dropRight } from 'lodash-es';

@Component({
  selector: 'app-read-only',
  templateUrl: './read-only.component.html',
  styleUrls: ['./read-only.component.scss']
})
export class ReadOnlyComponent implements OnInit {
  @Input() readonlyText: string|null = null;
  @Input() toolTipMessage: string|null = null;
  @Input() tooltipPosition: string = "bottom";
  constructor() { }

  ngOnInit(): void {
  }

}
